export const accordionDefaultProps = {
  chevronPosition: 'right',
  showDescription: false,
  open: false,
  disabled: false,
  withBorder: false
};